// extracted by mini-css-extract-plugin
module.exports = {"authorCard":"AuthorPanel_authorCard__3ab0h","textContainer":"AuthorPanel_textContainer__20e9H","iconContainer":"AuthorPanel_iconContainer__VGnOK","icon":"AuthorPanel_icon__KlhJG"};